export default __webpack_public_path__ + "static/media/tv_new.131a0126.webp";